import React from "react";
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
import { graphql, useStaticQuery } from 'gatsby'

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import CompassBlue from "components/Background/CompassBlue.jsx";

import ctaSectionStyle from "assets/jss/material-kit-react/components/ctaSectionStyle.jsx"

import WaitlistForm from "components/WaitlistForm/WaitlistForm.jsx";

class CTASection extends React.Component {
  render() {
  const {
    id,
    classes,
    className,
    style,
    backgroundImage,
    filterOpacity,
    withMargin,
    cta,
    fullWidth,
    modal,
    onSuccess,
    onFailure,
    onClose,
    listIds
  } = this.props;

  const filterType = function(filterOpacity) {
    if (filterOpacity >= 0.5) return "filterExtraDark";
    if (filterOpacity >= 0.4) return "filterDark";
    if (filterOpacity >= 0.3) return "filterMedium";
    if (filterOpacity < 0.3) return "filterLight";
  }(filterOpacity);
  return (
    <div id={id ? id : ""} className={classNames(classes.containerParent, classes[filterType], className)} style={{
          position: "relative",
          ...style
    }}>
      <div className={classNames(classes.container)}>
        <GridContainer justify="space-around">
          <GridItem className={classes.gridContainerItem} xs={fullWidth ? 11 : 11} sm={fullWidth ? 11 :10} md={fullWidth ? 11 :8} >
            <h2 className={classes.title}>
              {!Array.isArray(cta["section-title"]) ? cta["section-title"] : cta["section-title"].map(item => {
                return (
                  <span className={classes.inlineBlock}>{item}&nbsp;</span>
                )
              })}
            </h2>
            <h3 className={classes.subtitle}>
              {!Array.isArray(cta.title) ? cta.title : cta.title.map(item => {
                return (
                  <span className={classes.inlineBlock}>{item}&nbsp;</span>
                )
              })}
            </h3>
            <h4 className={classes.subSubtitle}> 
              {!Array.isArray(cta.subtitle) ? cta.subtitle : cta.subtitle.map(item => {
                return (
                  <span className={classes.inlineBlock}>{item}&nbsp;</span>
                )
              })}
            </h4>
            {!Array.isArray(cta.text) ? <p>cta.text</p> : cta.text.map(item => {
              return (
                <p className={classes.text}>{item}</p>
              )
            })}
            <WaitlistForm classes={classes} buttonText={cta.button.text} listIds={listIds}/>
            {this.props.children}
          </GridItem>
        </GridContainer>
      </div>
    </div>
  )}
}

CTASection.defaultProp = {
  backgroundImage: "none",
  filterOpacity: "0.3",
  fullWidth: false,
  modal: false
};

CTASection.propTypes = {

};

export default withStyles(ctaSectionStyle)(CTASection);